import React, { useEffect } from 'react';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { useForm, FormProvider } from 'react-hook-form';
import { useDeleteShopGroupUseCase } from '../hooks/delete-shop-group-use-case';

type DeleteShopGroupProps = {
  id: string;
  parentId: string;
  type: string;
  name: string;
  open: boolean;
  setOpen: (open: boolean) => void;
};

export type DeleteShopGroupFormValues = {
  id: string;
};

export const DeleteShopGroupAlertDialog: React.FC<DeleteShopGroupProps> = (props) => {
  const { loading, onDelete } = useDeleteShopGroupUseCase(props.id, props.parentId, props.type, props.setOpen);
  const deleteShopGroupForm = useForm<DeleteShopGroupFormValues>();

  useEffect(() => {
    deleteShopGroupForm.reset({ id: props.id });
  }, [props]);

  const { handleSubmit } = deleteShopGroupForm;

  return (
    <Dialog fullWidth maxWidth="md" open={props.open} onClose={() => props.setOpen(false)}>
      <FormProvider {...deleteShopGroupForm}>
        <form onSubmit={handleSubmit(onDelete)} autoComplete="off" noValidate>
          <DialogTitle>店舗グループ削除</DialogTitle>
          <DialogContent>
            店舗グループ <strong>{props.name}</strong> を削除します。よろしいですか？
          </DialogContent>
          <DialogActions>
            <Button onClick={() => props.setOpen(false)} color="secondary" disabled={loading}>
              キャンセル
            </Button>
            <Button type="submit" color="secondary" disabled={loading}>
              {loading ? <CircularProgress size="1rem" /> : '削除する'}
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </Dialog>
  );
};
